/**
 * Feedback Block Renderer
 * Dynamically renders the appropriate feedback block component based on type
 */

import { FeedbackBlock } from "@/types/interview-feedback.types";
import { GaugeBlock } from "./GaugeBlock";
import { ScoreGridBlock } from "./ScoreGridBlock";
import { TextBlock } from "./TextBlock";
import { TranscriptBlock } from "./TranscriptBlock";
import { logger } from "@/utils/logger"

interface FeedbackBlockRendererProps {
  block: FeedbackBlock;
  compact?: boolean;
  showAverageIndicator?: boolean;
}

export const FeedbackBlockRenderer = ({
  block,
  compact = false,
  showAverageIndicator = false,
}: FeedbackBlockRendererProps) => {
  switch (block.type) {
    case "gauge":
      return <GaugeBlock block={block} />;

    case "score_grid":
      return (
        <ScoreGridBlock
          block={block}
          compact={compact}
          showAverageIndicator={showAverageIndicator}
        />
      );

    case "text_block":
      return <TextBlock block={block} />;

    case "transcript":
      return <TranscriptBlock block={block} />;

    default:
      logger.warn("[FeedbackBlockRenderer] Unknown block type:", block);
      return null;
  }
};
